import src from "IMAGE";
export default { src, width: 681, height: 681, blurWidth: 0, blurHeight: 0};
